import { Button, Form, Input, Spin, notification, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import cookie from "react-cookies";

const Login = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  // onChange Handler for cookie to save token
  const onChange = (newName) => {
    const oneDayInSeconds = 24 * 60 * 60; // 1 day in seconds
    cookie.save("token", newName, { path: "/", maxAge: oneDayInSeconds });
  };

  // notification handler
  const openNotification = (message, description) => {
    notification.open({
      message: message,
      description: description,
    });
  };

  // onFinish
  const onFinish = (values) => {
  setLoader(true);

  axios
    .post(`${process.env.REACT_APP_FRONTED_URL}/auth/login`, values)
    .then((response) => {
      const token = response?.data?.token;
      const role = response?.data?.user?.role;

      onChange(token && JSON.stringify(token));

      cookie.save("role", role, { path: "/" }); // ✅ store role

      setLoader(false);
      message.success("You are logged in successfully");

      if (role === "event_operator") {
        navigate("/event-contacts");
      } else {
        navigate("/dashboard");
      }
    })
    .catch((error) => {
      setLoader(false);
      openNotification("Error", error?.response?.data?.message);
    });
};


  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-left">
          <div className="login-logo-box">
            <h1>Empire Infreactech</h1>
            <p>Your Dashboard, Your Domain</p>
          </div>
        </div>

        <div className="login-right">
          <h2 className="login-title">Login to Empire</h2>

          <Form layout="vertical" onFinish={onFinish} className="login-form">
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please enter your email" }]}
              className="email-container"
            >
              <Input placeholder="Enter your email" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your password" },
              ]}
              className="pass-container"
            >
              <Input.Password placeholder="Enter your password" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-btn"
                disabled={loader}
              >
                {!loader ? "Log In" : <Spin />}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default Login;
